import { Action } from '@ngrx/store';

import { FetchFromLocalStorage } from '@digihaven/shared';

import { OrganisationActions, OrganisationActionTypes } from '@actions/organisation.actions';

import { OrganisationState } from 'state';

const emptyState: OrganisationState = {
    organisation: {
        Id: '',
        ExternalId: '',
        Name: '',
        LongName: '',
        ApplicationScope: '',
        Modules: []
    }
};

export const initialState: OrganisationState = FetchFromLocalStorage('organisation') || emptyState;

export function organisationReducer(state = initialState, action: Action): OrganisationState {
    const organisationAction: OrganisationActions = action as OrganisationActions;

    switch (organisationAction.type) {
        case OrganisationActionTypes.Set:
            return { ...state, organisation: organisationAction.payload };
        case OrganisationActionTypes.Unset:
            return { ...emptyState };
        default:
            return state;
    }
}
